import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "../../Assets/CSS/Styles.scss";
import { API_BASE_URL } from '../../config';
const API_URL = `${API_BASE_URL}/uploads`;

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/blogs/type/blogs`)
      .then((res) => {

        const data = res.data;
        console.log("Blogs=", data);
        if (Array.isArray(data)) {
          setBlogs(data);
        } else if (Array.isArray(data.data)) {
          setBlogs(data.data);
        } else {
          setBlogs([]);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching blogs:", err);
        setBlogs([]);
        setLoading(false);
      });
  }, []);



  if (loading) {
    return <p className="text-center py-10">Loading blogs...</p>;
  }


  const featuredBlog = blogs.find((blog) => blog.type === "featured") || blogs[0];
  const regularBlogs = blogs.filter((blog) => blog._id !== featuredBlog._id);


  return (
    <div>

      <div className="container mx-auto px-6 py-12 max-w-7xl mt60">
        {/* Category and Section Title */}
        <div className="mb-12">
          <p className="text-[18px] mb-2 color: #374151 font-ui">Category</p>
          <h1 className="text-5xl md:text-6xl font-heading text-[#FBBF24]">Blogs</h1>
        </div>


        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Main Content Area */}

          <div className="lg:col-span-2">
            {blogs.length === 0 ? (
              <div className="text-center py-20 bg-white rounded-lg shadow-md">
                <h3 className="text-2xl font-bold text-gray-700 mb-4">
                  No Blogs Available
                </h3>
                <p className="text-gray-500">
                  We're working on some amazing content. Stay tuned!
                </p>
              </div>
            ) : (
              <>
                {/* Featured Blog */}
                {featuredBlog && (
                  <div className="mb-12">
                    <h3 className="font-heading mb-4 text-[25px] font-bold">Featured Insight</h3>
                    <div className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col transition-all duration-300 hover:scale-105 hover:shadow-lg"
                    >

                      <img
                        src={`${API_BASE_URL}/uploads/${featuredBlog.image}`}
                        alt={featuredBlog.title}
                        className="w-full h-64 object-cover"
                      />
                      <div className="p-6">
                        <h2 className="font-heading mb-4 text-[25px] font-bold">{featuredBlog.title}</h2>
                        <p className="text-[15px] mb-4">{featuredBlog.overview}</p>
                        <div className="flex items-center text-gray-500 text-sm mb-4 space-x-4">
                          <span className="flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                            {featuredBlog.author}
                          </span>
                          <span className="flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                d="M8 7V3m8 4V3m-9 8h.01M12 11h.01M15 11h.01M7 16h.01M12 16h.01M15 16h.01M18 6H6a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2z" />
                            </svg>
                            {new Date(featuredBlog.publishDate).toLocaleDateString()}
                          </span>
                        </div>
                        <Link
                          to={`/blog/${featuredBlog._id}`}
                          className="text-[#5B42F3] font-semibold flex items-center gap-1 hover:underline"
                        >
                          Read More
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                              d="M17 8l4 4m0 0l-4 4m4-4H3" />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}

                {/* Regular Blogs */}
                {/* All Blogs */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  {regularBlogs.map((blog) => (
                    <div key={blog._id} className="bg-white rounded-lg shadow-md overflow-hidden flex flex-col transition-all duration-300 hover:scale-105 hover:shadow-lg"
                    >
                      <img
                        src={`${API_URL}/${blog.image}`}
                        alt={blog.title}
                        className="w-full h-48 object-cover"
                      />
                      <div className="p-6">
                        <h3 className="font-heading mb-2 text-[25px] font-bold">{blog.title}</h3>
                        <p className="text-[15px] mb-4">{blog.overview}</p>
                        <div className="flex items-center text-gray-500 text-sm mb-4 space-x-4">
                          <span className="flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                            {blog.author}
                          </span>
                          <span className="flex items-center">
                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                d="M8 7V3m8 4V3m-9 8h.01M12 11h.01M15 11h.01M7 16h.01M12 16h.01M15 16h.01M18 6H6a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2z" />
                            </svg>
                            {new Date(blog.publishDate).toLocaleDateString()}
                          </span>
                        </div>
                        <Link
                          to={`/blog/${blog._id}`}
                          className="text-[#5B42F3] font-semibold flex items-center gap-1 hover:underline"
                        >
                          Read More
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                              d="M17 8l4 4m0 0l-4 4m4-4H3" />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-1 h-full flex flex-col">

            <div className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-2xl shadow-lg border border-gray-100 mb-6">

              <div className="flex items-center gap-3">
                <span className="w-2 h-8 rounded-full bg-gradient-to-b from-[#FBBF24] to-[#F59E0B]"></span>
                <h3 className="font-heading text-[20px] font-bold text-gray-800">
                  Categories
                </h3>
              </div>


              <ul className="space-y-3">
                {[
                  { label: "Digital Transformation", icon: "🚀" },
                  { label: "Case Studies", icon: "📊" },
                  { label: "College & School Automation", icon: "🎓" },
                  { label: "ERP Solutions", icon: "⚙️" },
                ].map((item, index) => (
                  <li
                    key={index}
                    className="group relative flex items-center justify-between px-4 py-3 rounded-xl bg-white hover:bg-[#F5F3FF] cursor-pointer transition-all shadow-sm hover:shadow-md"
                  >
                    {/* Left Accent Bar */}
                    <span className="absolute left-0 top-0 h-full w-1 bg-transparent group-hover:bg-[#5B42F3] rounded-l-xl transition-all"></span>

                    <div className="flex items-center gap-3">
                      <span className="text-sm">{item.icon}</span>
                      <span className="font-small text-gray-800 group-hover:text-[#5B42F3]">
                        {item.label}
                      </span>
                    </div>

                    <span className="text-gray-300 group-hover:text-[#5B42F3] transition">
                      →
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 flex-1">
              <div className="flex items-center gap-3">
                <span className="w-2 h-8 rounded-full bg-gradient-to-b from-[#5B42F3] to-[#7C6CF6]"></span>
                <h3 className="font-heading text-[20px] font-bold text-gray-800">
                  Recent Blogs
                </h3>
              </div>

              <ul className="divide-y divide-gray-100">
                {blogs.slice(0, 4).map((blog, index) => (
                  <li key={blog._id} className="py-4">
                    <Link
                      to={`/blog/${blog._id}`}
                      className="group flex gap-4 items-start"
                    >
                      {/* Index */}
                      <span className="text-sm font-bold text-gray-300 group-hover:text-[#5B42F3]">
                        0{index + 1}
                      </span>

                      <div>
                        <p className="font-medium text-gray-800 leading-snug group-hover:text-[#5B42F3] line-clamp-2">
                          {blog.title}
                        </p>
                        <p className="text-xs text-gray-400 mt-1">
                          {new Date(blog.publishDate).toLocaleDateString()}
                        </p>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>

      </div>
      {/* Bottom Call to Action */}
      <section className="bg-blue-900 text-white py-16">
        <div className="container mx-auto text-center px-6 max-w-4xl">
          <h2 className="font-heading font-bold mb-4 text-[30px]">
            Enjoyed the blog? Let's build something great together.
          </h2>
          <p className="text-[18px] font-ui mb-8">
            Ready to transform your institution with cutting-edge ERP solutions?
          </p>
          <Link to="/freedemo" className="inline-block">
            <button className="bg-[#F59E0B] hover:bg-[#f3b541] text-[#0b1120] px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2">
              Book Free Demo
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Blogs;
